module.exports = __webpack_public_path__ + "img/1477883372.d3e7f04c.jpg";